module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=GA - Gabon.420d1da7.svg";